export const DEFAULT_UNAVAILABLE = "N/A";

// Static string constants keep these Tailwind classes in the scanner's scope.
// They cannot be safelisted globally as they are specific to this component.
export const STICKY_OFFSET_ALL =
  "[&_.sticky.top-0.z-40]:top-[var(--sticky-cta-height,88px)] [&_.sticky.top-0.z-30]:top-[var(--sticky-cta-height,88px)] [&_.sticky.top-0.z-20]:top-[var(--sticky-cta-height,88px)]";
export const STICKY_OFFSET_MOBILE =
  "[&_.sticky.top-0.z-40]:top-[var(--sticky-cta-height,88px)] [&_.sticky.top-0.z-30]:top-[var(--sticky-cta-height,88px)] [&_.sticky.top-0.z-20]:top-[var(--sticky-cta-height,88px)] xl:[&_.sticky.top-0.z-40]:top-0 xl:[&_.sticky.top-0.z-30]:top-0 xl:[&_.sticky.top-0.z-20]:top-0";
